import React, { useEffect, useState } from 'react';

function ScoreCard({ url, scoreOrTvLive, status }) {
    const [flagStatus, setflagStatus] = useState();
  useEffect(() => {
    setflagStatus(scoreOrTvLive)
    // Do something when url changes (if needed)
  }, [url,scoreOrTvLive]);

  return (
      <div key={url} dangerouslySetInnerHTML={{ __html: url }} />
  );
}

// 👇 Memoize with custom comparison
export default React.memo(ScoreCard, (prevProps, nextProps) => {
  return prevProps.url === nextProps.url;
});
